import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateShowcaseEntity } from '../../domain/entities/CreateUpdateShowcaseEntity'
import { ShowcaseType } from '@/features/showcase/domain/enums/ShowcaseType'
import { ShowCasePeriodModel } from './ShowCasePeriodModel'
import type { ShowCasePeriodEntity } from '../../domain/entities/ShowCasePeriodEntity'

export class CreateUpdateShowcaseModel extends CreateUpdateShowcaseEntity {
  channelId!: number

  constructor(dataDto: CreateUpdateShowcaseEntity) {
    super()
    const shifts = dataDto.showcaseShiftDays?.filter(
      (shift) => shift.periods && shift.periods?.length > 0
    )
    mapEntityProperties<CreateUpdateShowcaseModel>(this, dataDto, {
      exclude: ['channel'],
      map: {
        channelId: dataDto.channel?.id,
        branches:
          dataDto.type === ShowcaseType.BRANCH
            ? dataDto.branches?.map((branch) => ({
                branchId: branch?.branchId
              }))
            : undefined,
        items:
          dataDto.type === ShowcaseType.ITEM
            ? dataDto.items?.map((item) => ({
                order: item.order,
                itemId: item?.id
              }))
            : undefined,
        showcaseShiftDays: shifts?.map((shift) => ({
          dayOfWeek: shift.dayOfWeek,
          periods: shift.periods?.map((period: ShowCasePeriodEntity) => {
            if (!period.startTimeDayOfWeek) {
              period.startTimeDayOfWeek = shift.dayOfWeek
            }
            if (!period.endTimeDayOfWeek) {
              period.endTimeDayOfWeek = shift.dayOfWeek
            }
            return new ShowCasePeriodModel(period)
          }),
        }))
      }
    })
  }
}
